import { render, staticRenderFns } from "./ModalProductLabelFooter.vue?vue&type=template&id=164975eb&"
import script from "./ModalProductLabelFooter.vue?vue&type=script&lang=js&"
export * from "./ModalProductLabelFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports